/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'action/fight': {
    width: 32,
    height: 32,
    viewBox: '0 0 32 32',
    data: '<g _fill="#1D1D1B"><path pid="0" d="M16 32C7.178 32 0 24.822 0 16S7.178 0 16 0s16 7.178 16 16-7.178 16-16 16zm0-30C8.28 2 2 8.28 2 16s6.28 14 14 14 14-6.28 14-14S23.72 2 16 2z"/><path pid="1" d="M16 4C9.371 4 4 9.371 4 16s5.371 12 12 12 12-5.371 12-12S22.629 4 16 4zm5.646 14.646a.5.5 0 01.707.707L21.207 20.5l2.146 2.146-.707.707-2.146-2.146-1.146 1.146a.5.5 0 11-.708-.706l1.146-1.146L16 16.707 12.207 20.5l1.146 1.146a.5.5 0 01-.707.708L11.5 21.207l-2.146 2.146-.707-.707 2.146-2.146-1.146-1.146a.5.5 0 01.707-.707l1.146 1.146L15.293 16 8.646 9.354l.707-.707L16 15.293l6.646-6.646.707.707L16.707 16l3.793 3.793 1.146-1.147z"/></g>'
  }
})
